export const investorProjects = [
  {
    id: 1,
    titleKey: 'investors.project1',
    descKey: 'investors.project1Desc',
    icon: 'ri-building-4-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20tennis%20court%20construction%20site%20with%20workers%20preparing%20surface%2C%20professional%20sports%20infrastructure%20development%2C%20green%20clay%20court%20being%20laid%2C%20construction%20equipment%2C%20blue%20sky%2C%20bright%20sunlight%2C%20development%20project%20photography&width=800&height=500&seq=inv-project-01&orientation=landscape',
  },
  {
    id: 2,
    titleKey: 'investors.project2',
    descKey: 'investors.project2Desc',
    icon: 'ri-graduation-cap-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20coaching%20academy%20classroom%20with%20whiteboard%20showing%20tennis%20tactics%2C%20certificates%20on%20wall%2C%20coaching%20manuals%20on%20desk%2C%20modern%20training%20facility%2C%20bright%20natural%20light%20through%20windows%2C%20educational%20institution%20feel&width=800&height=500&seq=inv-project-02&orientation=landscape',
  },
  {
    id: 3,
    titleKey: 'investors.project3',
    descKey: 'investors.project3Desc',
    icon: 'ri-billiards-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20padel%20tennis%20court%20with%20glass%20walls%20and%20blue%20artificial%20turf%2C%20surrounded%20by%20palm%20trees%2C%20luxury%20sports%20facility%2C%20bright%20sunlight%2C%20Mediterranean%20style%20architecture%2C%20premium%20club%20atmosphere%2C%20beautiful%20daytime&width=800&height=500&seq=inv-project-03&orientation=landscape',
  },
  {
    id: 4,
    titleKey: 'investors.project4',
    descKey: 'investors.project4Desc',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Young%20African%20tennis%20players%20training%20intensively%20at%20a%20sports%20academy%2C%20group%20of%20teenagers%20running%20drills%20on%20court%2C%20coaches%20supervising%2C%20academy%20building%20in%20background%2C%20green%20courts%2C%20professional%20training%20environment%2C%20bright%20daylight&width=800&height=500&seq=inv-project-04&orientation=landscape',
  },
  {
    id: 5,
    titleKey: 'investors.project5',
    descKey: 'investors.project5Desc',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=Map%20of%20Africa%20highlighting%20Central%20African%20region%20with%20tennis%20icons%20connecting%20countries%2C%20network%20visualization%2C%20international%20sports%20partnership%20concept%2C%20warm%20golden%20and%20green%20color%20palette%2C%20professional%20business%20graphic%20design&width=800&height=500&seq=inv-project-05&orientation=landscape',
  },
];

export const marketStats = [
  { titleKey: 'investors.market1Title', descKey: 'investors.market1Desc', icon: 'ri-group-line' },
  { titleKey: 'investors.market2Title', descKey: 'investors.market2Desc', icon: 'ri-line-chart-line' },
  { titleKey: 'investors.market3Title', descKey: 'investors.market3Desc', icon: 'ri-speed-up-line' },
  { titleKey: 'investors.market4Title', descKey: 'investors.market4Desc', icon: 'ri-medal-line' },
];